/* 🤖 this file was generated by svg-to-ts */
export const DfIconHeart16: {
  name: 'heart-16';
  data: string;
} = {
  name: 'heart-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8.004 2.71.471-.459c1.848-1.798 4.698-1.64 6.365.354s1.52 5.067-.328 6.865l-5.124 4.94a2 2 0 0 1-2.776 0L1.517 9.499c-1.862-1.78-2.034-4.853-.383-6.862C2.785.628 5.634.443 7.496 2.223z"/></svg>`
};
